import { RootEpic } from 'typesafe-actions';

import { createGetEpic } from '../utils';
import { getAvailableCurrencyListAsync } from './actions';

export const loadAvailableCurrencies: RootEpic = (
  action$,
  state$,
  { getAvailableCurrencyListSubscription }
) =>
  createGetEpic(
    action$,
    getAvailableCurrencyListAsync,
    getAvailableCurrencyListSubscription
  );
